import translation from './en-US.json';

export const locales = {
  'en-US': translation,
};
